export const TimeSlot = ({
    timeSlots,
    zoomInOut,
    weeklyView
}) => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes();
    const roundedMinutes = minutes >= 30 ? "30" : "00"; 
    const currentSlot = `${hours}:${roundedMinutes}`;
    return (
        <div className={`border-middle-container rounded border-0 py-0`}>
            <div className={`middle-down ${weeklyView? "mt-2" : ""}`}>
                <div className="content-wrapper" style={{height: 'auto', overflow: "hidden"}}>
                    <table className="scheduling-table tbl-50-per">
                        <tbody>
                            <div className="row w-100">
                                {/* Render timeSlots in a separate loop */}
                                <div className="time-slots-container col-2 p-2 text-center" style={{height: `${(30*timeSlots.length*zoomInOut)}px`}}>
                                    {timeSlots?.map((slot, index) => {
                                        const isActive = slot >= currentSlot;
                                        return (
                                            <div 
                                                key={index}
                                                style={{ 
                                                    // width: "100px", 
                                                    width: "3rem", 
                                                    height: `${30 * zoomInOut}px` 
                                                }}
                                                className="time-slot"
                                                {...(slot === "05:30" ? { id: "targetOnTime" } : {})}
                                            >
                                                <p className={`${isActive ? "text-info": ""}`}>{slot}</p>  {/* Customize this to display relevant time slot info */}
                                            </div>
                                        )
                                    })}
                                </div>
                                {/* Render gridList as you already have it */}
                            </div>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}